export default __webpack_public_path__ + "static/media/extra-bin.3de7cdd7.svg";